import {gql, MutationHookOptions, useMutation} from '@apollo/client';

const subscribe = gql`
mutation ($email: Email!, $path: String!) {
	contact {
		capture(
			reason: NEWSLETTER,
			email: $email,
			path: $path,
		)
	}
}`;

interface Vars {
	email: string;
	path: string;
}

export interface Result {
	contact: {
		capture: boolean;
	}
}

export const useSubscribe = (
	options?: MutationHookOptions<Result, Vars>,
) => {
	return useMutation<Result, Vars>(
		subscribe, options,
	);
};
